var _defs, _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrownyFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Frowny_Face",
    "data-name": "Frowny Face",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".frowny-cls-1{fill:#ff5c0f;}.frowny-cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Frowny Face") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "frowny-cls-1",
    cx: 20.5,
    cy: 20.5,
    r: 20.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "frowny-cls-2",
    cx: 12.89,
    cy: 14.73,
    r: 3.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "frowny-cls-2",
    cx: 28.26,
    cy: 14.73,
    r: 3.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "frowny-cls-2",
    d: "M81.56,84H60.62a2.34,2.34,0,0,1-2-3.59c2.14-3.36,6.17-7.86,12.45-7.86S81.4,77,83.53,80.39A2.34,2.34,0,0,1,81.56,84Z",
    transform: "translate(-51 -52)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrownyFace);
export default __webpack_public_path__ + "static/media/Frowny Face.a0d0c78dfeb40c02782fd1b6014512fb.svg";
export { ForwardRef as ReactComponent };